/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/alt-text */

// React & Libraries
import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

// Ant Design
import { notification, Table } from 'antd';
import { CheckOutlined, EditFilled } from '@ant-design/icons';

// UI Libraries
import H3Text from '@Uilib/h3Text';

// Constants & Helpers
import { QUANTITY } from '@Apis/constants';
import Helpers from '@Apis/helpers';
import CustomFieldHelpers from '../../../../../helpers/CustomFieldHelpers';

// Common Components
import ProductCategoryLabel from '../../../../Common/ProductCategoryLabel';
import HideValue from '../../../../Common/RestrictedAccess/HideValue';
import PRZModal from '../../../../Common/UI/PRZModal';

// File specific components
import './style.scss';

// Actions
import DCActions from '@Actions/dcActions';
import quickUpdateActions from '../../../../../actions/quickUpdate/quickUpdateActions';
import ActivityLogActions from '@Actions/activityLogActions';

function DCLines({
  priceMasking,
  dcLines,
  selectedDC,
  updateData,
  quickUpdateEntityWise,
  getActivityLog,
  user,
  MONEY,
  cfDeliveryChallanLine,
}) {

  const [state, setState] = useState({
    showPRZModal: false,
    selectedDocumentId: null,
  });

  const {
    showPRZModal,
    selectedDocumentId,
  } = state;

  const updateState = (newState) => {
    setState((oldState) => ({
      ...oldState,
      ...newState,
    }));
  };

  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

  const dcLinesColumns = [
    {
      title: "",
      responsive: ["xs"],
      render: (record) => (
        <div className="mobile-list__item">
          <div style={{ display: "flex", gap: "2%" }}>
            <div>{"SKU#: "}</div>
            <div style={{ whiteSpace: "nowrap" }}>
              <Link
                to={`/inventory/product/view/${record?.tenant_product_info?.product_sku_id}`}
                target="_blank"
              >
                {record?.tenant_product_info?.internal_sku_code}
              </Link>
            </div>
          </div>
          <div>{`Product: ${record?.tenant_product_info?.product_sku_name}`}</div>
          <div>{`HSN/SAC CODE: ${record.tenant_product_info?.hsn_code || ""
            }`}</div>
          <div>{`Quantity: ${QUANTITY(record?.quantity)} ${record?.tenant_product_info?.uqc?.toProperCase() || ""
            }`}</div>
        </div>
      ),
    },
    {
      title: "PRODUCT",
      responsive: ["sm", "md", "lg", "xxl"],
      render: (item) => {
        return (
          <Fragment>
            {/* <Link
            to={`/inventory/product/view/${item?.tenant_product_info?.product_sku_id}`}
            target="_blank"
          >
            {`#${item?.tenant_product_info?.internal_sku_code}`}
          </Link> */}
            <Fragment>
              <div
                onClick={() =>
                  updateState({
                    showPRZModal: true,
                    selectedDocumentId:
                      item?.tenant_product_info?.product_sku_id,
                  })
                }
              >
                <a>{`#${item?.tenant_product_info?.product_sku_name}`}</a>
              </div>
            </Fragment>
            <div>{item?.tenant_product_info?.product_sku_name}</div>
            {item?.product_sku_info?.product_category_info?.category_path?.length > 0 && (
              <ProductCategoryLabel
                categoryPath={
                  item?.product_sku_info?.product_category_info
                    ?.category_path
                }
                categoryName={item?.product_sku_info?.product_category_info?.category_path?.at(
                  -1
                )}
                containerStyle={{
                  width: "fit-content",
                }}
              />
            )}
            <div
              dangerouslySetInnerHTML={{ __html: item?.remarks }}
              className="table-subscript"
              style={{
                width: "200px",
                whiteSpace: "pre-wrap",
              }}
            />
            <div style={{ display: "flex", alignItems: "center" }}>
              <div>
                {item?.tenant_product_info?.product_type === "BUNDLE" && (
                  <H3Text
                    text="Bundle"
                    className="table-subscript table-subscript-tag"
                  />
                )}
                {item?.tenant_product_info?.product_type === "SERVICE" && (
                  <H3Text
                    text="Service"
                    className="table-subscript table-subscript-tag"
                  />
                )}
                {!["SERVICE", "BUNDLE"].includes(
                  item?.tenant_product_info?.product_type
                ) &&
                  (
                    <H3Text
                      text="Goods"
                      className="table-subscript table-subscript-tag"
                    />
                  )
                }
              </div>
              <div
                style={{
                  fontSize: "10px",
                  display: "flex",
                  marginLeft: "5px",
                  marginTop: "7px",
                }}
              >
                <H3Text
                  text={
                    item?.tenant_product_info?.product_type === "SERVICE"
                      ? "SAC - "
                      : "HSN - "
                  }
                />
                &nbsp;
                <div className="dc-table__hsn-value">
                  {item?.hsn_code_isEditable ? (
                    <div className="view-dc-table__hsn-value">
                      <input
                        value={item.hsn_code}
                        onChange={(e) => {
                          const copyData = JSON.parse(
                            JSON.stringify(dcLines)
                          );
                          copyData.map((record) => {
                            if (item.key === record.key) {
                              record.hsn_code = e.target.value;
                            }
                            return dcLines;
                          });
                          updateData(copyData);
                        }}
                        onKeyPress={(e) => {
                          if (e.key === "Enter") {
                            const copyData = JSON.parse(
                              JSON.stringify(dcLines)
                            );
                            copyData.map((record) => {
                              if (item.key === record.key) {
                                record.hsn_code_isEditable = false;
                              }
                              return dcLines;
                            });
                            updateData(copyData);
                            quickUpdateEntityWise(
                              {
                                hsn_code: item.hsn_code
                                  ? item.hsn_code
                                  : " ",
                                delivery_challan_id:
                                  selectedDC?.delivery_challan_id,
                                delivery_challan_line_id:
                                  item?.delivery_challan_line_id,
                                entity_name: 'DELIVERY_CHALLAN',
                              },
                              () => {
                                getActivityLog(selectedDC?.delivery_challan_id, 'delivery_challan', 1, 10);
                              }
                            );
                          }
                        }}
                        className="dc-table__hsn-input"
                        maxLength="10"
                      />
                      &nbsp;
                      <CheckOutlined
                        style={{ color: "#1890ff", cursor: "pointer" }}
                        onClick={() => {
                          const copyData = JSON.parse(
                            JSON.stringify(dcLines)
                          );
                          copyData.map((record) => {
                            if (item.key === record.key) {
                              record.hsn_code_isEditable = false;
                            }
                            return dcLines;
                          });
                          updateData(copyData);
                          quickUpdateEntityWise(
                            {
                              hsn_code: item.hsn_code
                                ? item.hsn_code
                                : " ",
                              delivery_challan_id:
                                selectedDC?.delivery_challan_id,
                              delivery_challan_line_id:
                                item?.delivery_challan_line_id,
                              entity_name: 'DELIVERY_CHALLAN',
                            },
                            () => {
                              getActivityLog(selectedDC?.delivery_challan_id, 'delivery_challan', 1, 10);
                            }
                          );
                        }}
                      />
                    </div>
                  ) : (
                    <div className="view-dc-table__hsn-value">
                      {item?.hsn_code && (
                        <H3Text
                          text={item?.hsn_code}
                          className="dc-table__hsn"
                        />
                      )}
                      {selectedDC?.status !== 'VOID' && Helpers.getPermission(Helpers.permissionEntities.DELIVERY_CHALLAN, Helpers.permissionTypes.UPDATE, user) && (<EditFilled
                        className="edit-icon"
                        onClick={() => {
                          const copyData = JSON.parse(
                            JSON.stringify(dcLines)
                          );
                          copyData.map((record) => {
                            if (selectedDC?.e_way_bills?.length > 0) {
                              notification.open({
                                type: "error",
                                message:
                                  "Cannot update HSN/SAC code after e-way bill is generated",
                                duration: 4,
                                placement: "top",
                              });
                            } else if (item?.key === record?.key) {
                              record.hsn_code_isEditable = true;
                            }
                          });
                          updateData(copyData);
                        }}
                      />)}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Fragment>
        );
      },
    },
    {
      title: "QUANTITY",
      responsive: ["sm", "md", "lg", "xxl"],
      render: (item) => (
        <div style={{ whiteSpace: "nowrap" }}>
          {`${QUANTITY(item?.quantity)} ${item?.uom_info?.[0]?.uqc?.toProperCase() || item?.tenant_product_info?.uqc?.toProperCase() || ""
            }`}
        </div>
      ),
    },
    {
      title: "UNIT PRICE",
      responsive: ["sm", "md", "lg", "xxl"],
      render: (item) => (
        <Fragment>
          {(isDataMaskingPolicyEnable && isHideSellingPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view unit price"} /> : MONEY(
            item.unit_price,
            selectedDC?.org_currency_info?.currency_code,
          )}
        </Fragment>
      ),
    },
    {
      title: "TAX",
      responsive: ["sm", "md", "lg", "xxl"],
      render: (item) => (
        <Fragment>{`${item?.tax_group_info?.tax_value || 0}%`}</Fragment>
      ),
    },
    {
      title: "DISCOUNT",
      responsive: ["sm", "md", "lg", "xxl"],
      render: (item) => (
        <Fragment>{`${item.line_discount_percentage || 0}%`}</Fragment>
      ),
    },
    {
      title: "LINE TOTAL",
      responsive: ["sm", "md", "lg", "xxl"],
      render: (item) => (
        <Fragment>
          {(isDataMaskingPolicyEnable && isHideSellingPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view line total"} /> : MONEY(
            item?.unit_price *
            (1 - item?.line_discount_percentage / 100) *
            item?.quantity *
            (1 + item?.tax_info?.tax_value / 100) || 0,
            selectedDC?.org_currency_info?.currency_code,
          )}
        </Fragment>
      ),
    },
  ];

  if (cfDeliveryChallanLine?.length) {
    dcLinesColumns.splice(4, 0, ...CustomFieldHelpers.renderCustomLineColumns(false, cfDeliveryChallanLine, {}, null));
  }

  return (
    <Fragment>
      <div className="pr-table-wrapper">
        <Table
          bordered
          showHeader
          title={() => `Delivery Challan Items (${dcLines?.length})`}
          size="small"
          columns={dcLinesColumns}
          dataSource={dcLines}
          pagination={false}
          scroll={{ x: true }}
        />
      </div>
      <PRZModal
        isOpen={showPRZModal}
        onClose={() => {
          updateState({ showPRZModal: false, selectedDocumentId: null });
        }}
        entityType="product"
        documentId={selectedDocumentId}
      />
    </Fragment>
  )
};

const mapStateToProps = ({ UserReducers, DCReducers }) => ({
  MONEY: UserReducers.MONEY,
  user: UserReducers.user,
  priceMasking: UserReducers.priceMasking,
  quickUpdateDeliveryChallanLoading: DCReducers.quickUpdateDeliveryChallanLoading,
});

const mapDispatchToProps = (dispatch) => ({
  quickUpdateDeliveryChallan: (payload, callback, rollback) => dispatch(DCActions.quickUpdateDeliveryChallan(payload, callback, rollback)),
  quickUpdateEntityWise: (payload, Callback, rollback) => dispatch(quickUpdateActions.quickUpdateEntityWise(payload, Callback, rollback)),
  getActivityLog: (entityId, entityName, page, limit, callback) => dispatch(ActivityLogActions.getActivityLog(entityId, entityName, page, limit, callback)),
});

DCLines.propTypes = {
  dcLines: PropTypes.any,
  selectedDC: PropTypes.any,
  MONEY: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DCLines));
